import { useMutation } from "@tanstack/react-query";

async function sendMagicLinkRequest(email: string, slug: string) {
  fetch(`${import.meta.env.VITE_AGENCY_API_URL}login`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${import.meta.env.VITE_AGENCY_API_TOKEN}`,
    },
    body: JSON.stringify({
      email,
      slug,
    }),
  });
}

export default function useWhitelabelMutations() {
  const {
    mutateAsync: sendMagicLink,
    isPending: isSendingMagicLink,
    isSuccess: isSendMagicLinkSuccess,
  } = useMutation({
    mutationFn: ({ email, slug }: { email: string; slug: string }) =>
      sendMagicLinkRequest(email, slug),
  });

  return {
    sendMagicLink,
    isSendingMagicLink,
    isSendMagicLinkSuccess,
  };
}
